module.exports = __webpack_public_path__ + "img/h-page4-43.aa405460.png";